if (!customElements.get("quick-add-modal")) {
  let quickAddModalInstance = 0;

  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        quickAddModalInstance += 1;
        this.quickAddOwnerId = `${this.id || "QuickAdd"}-${quickAddModalInstance}`;

        window.addEventListener("keyup", (event) => {
          const eventModal =
            event.target instanceof Element
              ? event.target.closest(
                  "modal-dialog.product-popup-modal[data-quick-add-owner]"
                )
              : null;
          if (
            event.code?.toUpperCase() === "ESCAPE" &&
            eventModal?.dataset.quickAddOwner !== this.quickAddOwnerId &&
            !this.hasOpenQuickAddProductModal()
          ) {
            this.hide();
          }
        });
        this.opener = null;
      }

      hide(preventFocus = false) {
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);

        document.querySelectorAll(".quick-add-modal .js-media-list").forEach((element) => {
          element.swiper?.destroy();
        });
        document.querySelectorAll(".quick-add-modal .js-media-sublist").forEach((element) => {
          element.swiper?.destroy();
        });

        this.removeQuickAddProductModals();
        this.modalContent.innerHTML = "";

        quickAddsliderInit(true);

        if (preventFocus) this.openedBy = null;
        super.hide();

        if (this.opener) {
          this.startSlider(this.opener);
        }
      }

      show(opener) {
        this.removeQuickAddProductModals();
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        this.stopSlider(opener);

        if (opener.querySelector(".loading-overlay__spinner")) {
          opener
            .querySelector(".loading-overlay__spinner")
            .classList.remove("hidden");
        }

        fetch(opener.getAttribute("data-product-url"))
          .then((response) => response.text())
          .then(async (responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            await this.ensureQuickViewAssets(responseHTML);
            this.productElement = responseHTML.querySelector(
              'section[id^="MainProduct-"]'
            );
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(
              this.modalContent,
              this.productElement.innerHTML,
              opener
            );
            this.modalContent.dispatchEvent(
              new CustomEvent("quickadd:loaded", { bubbles: true })
            );

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");

            if (opener.querySelector(".loading-overlay__spinner")) {
              opener
                .querySelector(".loading-overlay__spinner")
                .classList.add("hidden");
            }

            document.querySelectorAll(".quick-add-modal .js-media-list").forEach((element) => {
          element.swiper?.destroy();
        });
            document.querySelectorAll(".quick-add-modal .js-media-sublist").forEach((element) => {
          element.swiper?.destroy();
        });

            quickAddsliderInit(true);

            const selectDropDown = () => {
              document.querySelectorAll(".product-form__controls--dropdown").forEach((dropdown) => {
                const list = dropdown.querySelector(".dropdown-select ul");
                const selectedText = dropdown.querySelector(".dropdown-select .select-label");
                if (!list || !selectedText || selectedText.dataset.quickAddDropdownBound === "true") return;
                selectedText.dataset.quickAddDropdownBound = "true";
                selectedText.addEventListener("click", (event) => {
                  event.stopPropagation();
                  list.classList.toggle("active");
                });
                document.addEventListener("click", () => list.classList.remove("active"));
                list.querySelectorAll("li").forEach((item) => {
                  item.addEventListener("click", () => {
                    const value = item.textContent.trim();
                    const span = selectedText.querySelector("span");
                    if (span) {
                      span.textContent = value;
                      span.setAttribute("title", value);
                    }
                    list.classList.remove("active");
                    document.activeElement?.blur();
                  });
                });
              });
            };

            selectDropDown();
          });
      }

      setInnerHTML(element, html, opener) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll("script").forEach((oldScriptTag) => {
          const newScriptTag = document.createElement("script");
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(
            document.createTextNode(oldScriptTag.innerHTML)
          );
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });

        // Read more button
        const moreBtn = document.createElement("a");
        //moreBtn.textContent = `${theme.quickviewMore}`;
        moreBtn.innerHTML = `<span>${theme.quickviewMore}</span>`;
        moreBtn.setAttribute("href", opener.getAttribute("data-product-url"));
        moreBtn.setAttribute(
          "class",
          "product__full-details button button--simple"
        );
        element
          .querySelector(".product .product__info-main_content")
          .appendChild(moreBtn);
      }

      ensureQuickViewAssets(responseHTML) {
        const requiredAssets = [
          "site-product.css",
          "site-product.js",
          "product-size-finder.css",
          "product-size-finder.js",
        ];
        const resources = Array.from(
          responseHTML.querySelectorAll('link[rel="stylesheet"][href], script[src]')
        );

        return Promise.all(
          requiredAssets.map((assetName) => {
            const resource = resources.find((element) => {
              const url =
                element.tagName === "LINK"
                  ? element.getAttribute("href")
                  : element.getAttribute("src");
              return url?.includes(`/assets/${assetName}`);
            });

            return resource ? this.ensureQuickViewAsset(resource) : Promise.resolve();
          })
        );
      }

      ensureQuickViewAsset(resource) {
        const isStylesheet = resource.tagName === "LINK";
        const attribute = isStylesheet ? "href" : "src";
        const sourceUrl = resource[attribute];
        const selector = isStylesheet
          ? 'link[rel="stylesheet"][href]'
          : "script[src]";
        const alreadyLoaded = Array.from(document.querySelectorAll(selector)).some(
          (element) => element[attribute] === sourceUrl
        );

        if (alreadyLoaded) return Promise.resolve();

        return new Promise((resolve) => {
          const asset = document.createElement(resource.tagName.toLowerCase());
          Array.from(resource.attributes).forEach((attributeNode) => {
            asset.setAttribute(attributeNode.name, attributeNode.value);
          });
          asset.dataset.quickAddAsset = "true";
          asset.addEventListener("load", resolve, { once: true });
          asset.addEventListener("error", resolve, { once: true });
          document.head.appendChild(asset);
        });
      }

      removeDOMElements() {
        const modal = this.productElement.querySelector("product-modal");
        if (modal) modal.remove();

        const popup = this.productElement.querySelectorAll(".product-popup");
        if (popup)
          popup.forEach((el) => {
            el.remove();
          });

        const reviews = this.productElement.querySelector(
          '[data-block-handle="reviews"]'
        );
        if (reviews) reviews.remove();

        const about = this.productElement.querySelectorAll(".about");
        if (about)
          about.forEach((el) => {
            el.remove();
          });

        const iconText = this.productElement.querySelectorAll(
          ".product__text-icon"
        );
        if (iconText)
          iconText.forEach((el) => {
            el.remove();
          });

        const shareButtons =
          this.productElement.querySelector(".share-buttons");
        if (shareButtons) shareButtons.remove();

        const tags = this.productElement.querySelector(".product-tags");
        if (tags) tags.remove();

        const pickupAvailability = this.productElement.querySelector(
          ".pickup-availability"
        );
        if (pickupAvailability) pickupAvailability.remove();

        const description = this.productElement.querySelector(
          ".product__description"
        );
        if (description) description.remove();

        const recommendations = this.productElement.querySelector(
          "product-recommendations"
        );

        if (recommendations) recommendations.remove();

        const product__popup =
          this.productElement.querySelector(".product__popup");
        if (product__popup) product__popup.remove();
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`
          );
        this.productElement
          .querySelectorAll("variant-selects, variant-radios")
          .forEach((variantSelect) => {
            variantSelect.dataset.originalSection = sectionId;
          });

        const modalOpeners = Array.from(
          this.productElement.querySelectorAll("modal-opener[data-modal]")
        );

        this.productElement
          .querySelectorAll("modal-dialog.product-popup-modal[id]")
          .forEach((modal, index) => {
            const originalModalId = modal.id;
            const uniqueModalId = `${originalModalId}-${this.quickAddOwnerId}-${index}`;
            const matchingOpeners = modalOpeners.filter(
              (modalOpener) =>
                modalOpener.getAttribute("data-modal") === `#${originalModalId}`
            );

            matchingOpeners.forEach((modalOpener, openerIndex) => {
              const originalOpenerId = modalOpener.id;
              const uniqueOpenerId = originalOpenerId
                ? `${originalOpenerId}-${this.quickAddOwnerId}-${openerIndex}`
                : "";

              modalOpener.setAttribute("data-modal", `#${uniqueModalId}`);

              if (originalOpenerId) {
                modalOpener.id = uniqueOpenerId;
                modal
                  .querySelectorAll("product-size-finder[data-opener-id]")
                  .forEach((sizeFinder) => {
                    if (sizeFinder.dataset.openerId === originalOpenerId) {
                      sizeFinder.dataset.openerId = uniqueOpenerId;
                    }
                  });
              }
            });

            modal.id = uniqueModalId;
            modal.dataset.quickAddOwner = this.quickAddOwnerId;
            modal.classList.add("quick-add-product-popup-modal");
            modal.querySelectorAll('[id^="ModalClose-"]').forEach((closeButton) => {
              closeButton.id = `${closeButton.id}-${this.quickAddOwnerId}-${index}`;
            });
          });
      }

      getQuickAddProductModals() {
        return Array.from(
          document.querySelectorAll(
            "modal-dialog.product-popup-modal[data-quick-add-owner]"
          )
        ).filter(
          (modal) => modal.dataset.quickAddOwner === this.quickAddOwnerId
        );
      }

      hasOpenQuickAddProductModal() {
        return this.getQuickAddProductModals().some((modal) =>
          modal.hasAttribute("open")
        );
      }

      removeQuickAddProductModals() {
        this.getQuickAddProductModals().forEach((modal) => modal.remove());
      }

      preventVariantURLSwitching() {
        if (this.modalContent.querySelector("variant-radios,variant-selects")) {
          this.modalContent
            .querySelector("variant-radios,variant-selects")
            .setAttribute("data-update-url", "false");
        }
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]'
        );
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector(".product");
        const desktopColumns = product.classList.contains("product--columns");
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let mediaImageSizes =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

        if (product.classList.contains("product--medium")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "605px");
        } else if (product.classList.contains("product--small")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "495px");
        }

        mediaImages.forEach((img) =>
          img.setAttribute("sizes", mediaImageSizes)
        );
      }

      // Product slider stop on quick add open and start on quick add close
      stopSlider(opener) {
        const productSlider = opener.closest(".product-slider");
        const productSwiper = productSlider?.querySelector(
          ".product-slider__product-swiper"
        );
        let isStopped = false;
        if (productSwiper && productSwiper?.swiper) {
          productSwiper.swiper.autoplay.stop();
          productSwiper.swiper.on("autoplayStart", () => {
            if (!isStopped) {
              productSwiper.swiper.autoplay.stop();
              isStopped = true;
              this.opener = opener;
            }
          });
        }
      }

      startSlider(opener) {
        const productSlider = opener.closest(".product-slider");
        const productSwiper = productSlider?.querySelector(
          ".product-slider__product-swiper"
        );

        if (productSwiper && productSwiper?.swiper) {
          productSwiper.swiper.autoplay.start();
          this.opener = null;
        }
      }
    }
  );
}
